import { Component } from '@angular/core';
import { filter } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';

import { ConfigurationService } from '@core/services/configuration.service';
import { ConvexConfig } from '@core/app-config';

declare const gtag: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  config: ConvexConfig;

  constructor(private configService: ConfigurationService, router: Router) {
    /**
     * Load app config
     */
    this.config = this.configService.getConfig();
    /**
     * Add google analytics script at runtime
     */
    const gaScript = document.createElement('script');
    gaScript.async = true;
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${this.config.gaCode}`;
    document.head.prepend(gaScript);

    /**
     * Send navigation end event to Google Analytics
     */
    const navEndEvent$ = router.events.pipe(
      filter((e) => e instanceof NavigationEnd)
    );
    navEndEvent$.subscribe((e: NavigationEnd) => {
      gtag('config', this.config.gaCode, {
        page_path: e.urlAfterRedirects,
        anonymize_ip: true,
      });
    });
  }
}
